import React, { forwardRef } from 'react'

import { IconProps } from './types'

const ChevronUpDown = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5.5 6.5L8 4L10.5 6.5M5.5 9.5L8 12L10.5 9.5" stroke={color} />
    </svg>
  ),
)

ChevronUpDown.displayName = 'ChevronUpDown'

ChevronUpDown.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default ChevronUpDown
